module.exports = __webpack_public_path__ + "img/img27.6ebf9a45.jpg";